<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="vx-row">
      <div class="w-full">
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec pt-6"
          id="view-customer-tab"
        >
          <div>
            <vx-card>
              <vs-table
                :max-items="paginationItems[0]"
                pagination
                :data="eventactionMappingData"
                :description="false"
                search
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.Hooks") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="
                        $router.push('/createEventAction').catch(() => {})
                      "
                      size="small"
                      >{{ $t("system.label.CreateEvent") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <th>{{ $t("system.label.Event") }}</th>
                  <th>{{ $t("system.label.Action") }}</th>
                  <th>{{ $t("system.label.Process") }}</th>
                  <th>{{ $t("system.label.OrderBy") }}</th>
                  <th>{{ $t("system.label.PrePost") }}</th>
                  <th>{{ $t("system.label.ProcessParams") }}</th>
                  <th>{{ $t("system.label.IsSynchronous") }}</th>
                  <th>{{ $t("system.label.Enabled") }}</th>
                  <th>{{ $t("system.label.ExternalSystem") }}</th>
                  <th class="tHeadCenter">
                    {{ $t("system.label.Actions") }}
                  </th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="eventData"
                    v-for="(eventData, index) in data"
                  >
                    <vs-td :data="eventData.eventName">{{
                      eventData.eventName
                    }}</vs-td>
                    <vs-td :data="eventData.actionName">{{
                      eventData.actionName
                    }}</vs-td>
                    <vs-td :data="eventData.process">{{
                      eventData.process
                    }}</vs-td>

                    <vs-td :data="eventData.orderBy">{{
                      eventData.orderBy
                    }}</vs-td>
                    <vs-td :data="eventData.prePost">{{
                      eventData.prePost
                    }}</vs-td>
                    <vs-td :data="eventData.processParams">{{
                      eventData.processParams
                    }}</vs-td>
                    <vs-td :data="eventData.is_synchronous">{{
                      eventData.is_synchronous
                    }}</vs-td>
                    <vs-td :data="eventData.isDeletedBool">
                      <vs-switch
                        :value="eventData.isDeletedBool"
                        @input="updateHooks(eventData.id)"
                      />
                    </vs-td>
                    <vs-td :data="eventData.externalSystem">{{
                      eventData.externalSystem
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('system.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editEventActionData(eventData.id)"
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>

        <!-- edit paymentgatway configuration -->
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],

      warningPopup: false,
      warningText: "",
      errorMessage: "",

      enabledOptions: [true, false],
      idEditPaymentConfig: "",
      activeTab: 0,
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters({
      configurationsData: "configuration/getConfigurationsList",
      paymentGatewayConfigsData: "configuration/getPaymentGatewayConfigsList",
      eventactionMappingData: "configuration/getEventactionMappingList",
      ByIdConfigurationsData: "configuration/getByIdConfigurationsDataList",
    }),
    ...mapState({
      enumConfig: (state) => state.configuration.enumConfig,
    }),
  },
  methods: {
    editEventActionData(id) {
      this.$router.push(`/editEventAction/${id}`);
    },
    async getEventactionMappingList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/setEventactionMappingList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async updateHooks(id) {
      try {
        await this.$store.dispatch("configuration/updateHooksFlagAction", id);
        // Assuming you have a method to refresh the hooks data, call it here
        this.getEventactionMappingList();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  },
  mounted() {
    this.getEventactionMappingList();
  },
};
</script>
<style scoped>
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.width15 {
  max-width: 15%;
  word-break: break-all;
}
.width20 {
  max-width: 20%;
  word-break: break-all;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.list-heading1 {
  font-size: 22px;
  font-weight: 500;
}
</style>
